<nav class="navbar" style="padding: 5px 10px;">
  <div class="nav-left">
    <img src="https://get.hubbleapp.ai/images/hubble-logo.svg" class="logo" style="max-width: 100px; margin-right: 20px;" />
    <a routerLink="/dashboard" style="margin: 0 10px;">Dashboard</a>
    <a routerLink="/account" style="margin: 0 10px;">Account</a>
  </div>
  <div class="nav-right">
    {{ userEmail }}
  </div>
</nav>

<router-outlet></router-outlet>